module.exports = __webpack_public_path__ + "static/img/homeProduct2.dac013a1.png";